import Barcode from 'react-barcode'
import styled from 'styled-components'

export const StyleReactBarcode = styled(Barcode)``

export const StyleValue = styled.div`
  text-align: center;
  margin-top: -4px;
  font-size: 14px;
  position: relative;
`

export const StyleReactBarcodeWrap = styled.div<{ $hideBorder?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  ${({ $hideBorder }) =>
    $hideBorder
      ? ''
      : ` svg {
  height: 60px;
  width: 100px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
}`}
`

interface IProps {
  width?: number
  height?: number
  value?: string
  displayValue?: boolean
  hideBorder?: boolean
}

const ReactBarcode = (props: IProps) => {
  const {
    value,
    displayValue,
    height = 70,
    width = 0.65,
    hideBorder,
    ...resProps
  } = props
  return (
    <StyleReactBarcodeWrap className="react-barcode" $hideBorder={hideBorder}>
      <StyleReactBarcode
        value={value || '0'}
        height={height}
        width={width}
        displayValue={false}
        {...resProps}
      />
      {displayValue && (
        <StyleValue className="react-barcode-value">{value}</StyleValue>
      )}
    </StyleReactBarcodeWrap>
  )
}

export default ReactBarcode
